<div fxLayout="column" class="pd-30 h100" style="background-color: white">
  <div id="paypal-button-container"></div>
  <mat-spinner *ngIf="loading" fxFlexAlign="center"></mat-spinner>

  <div class="" fxFlex></div>
  <app-order-details-total
    style="margin-bottom: 30px"
    *ngIf="!checkoutService.createSavingPlanTypes.includes((checkoutService.selectedPaymentRequest | async)?.type) && !(subscriptionId || id)"
    [shippingPrice]="checkoutService.shippingPrice | async"
    [totalPrice]="checkoutService.totalPrice | async"
    [taxIncludes]="true"
    [showDeliveryPrice]="checkoutService.redirectToPaymentList.includes((checkoutService.selectedPaymentRequest | async)?.type)">
  </app-order-details-total>
</div>
